import { Injectable, Inject} from '@angular/core';


export  class PolicyAgentDO {
    // private firstName;
    // private lasteName;
    public  id:Number = null;
	
	public agentNum:String = null;
	
	public  primaryFl:Boolean = null;
	
	public commissionPercent:String = null;
	
	public getId():Number {
		return this.id;
	}
	public getAgentNum():String {
		return this.agentNum;
	}
	public  setAgentNum(agentNum):void {
		this.agentNum = agentNum;
	}
	public  isPrimaryFl():Boolean {
		return this.primaryFl;
	}
	public  setPrimaryFl( primaryFl):void {
		this.primaryFl = primaryFl;
	}
	public getCommissionPercent():String {
		return this.commissionPercent;
	}
	public  setCommissionPercent(commissionPercent):void {
		this.commissionPercent = commissionPercent;
	}
	public  setId(id):void {
		this.id = id;
	}
	// public getObjectName() {
	// 	return this.PolicyAgentDO.class.getSimpleName();
	// }



}
